export const PRODUCT_IMAGE_VIEW_TYPES = {
    SFS: 'SFS',
    SFA: 'SFA',
    SN: 'SN',
    LAB: 'LAB',
    TXT: 'TXT',
} as const;

export type ProductImageViewType = (typeof PRODUCT_IMAGE_VIEW_TYPES)[keyof typeof PRODUCT_IMAGE_VIEW_TYPES];

/** Product-image groups shown by physical PDP galleries, in display order. */
export const PDP_GALLERY_VIEW_TYPES = [
    PRODUCT_IMAGE_VIEW_TYPES.SFS,
    PRODUCT_IMAGE_VIEW_TYPES.SFA,
    PRODUCT_IMAGE_VIEW_TYPES.SN,
    PRODUCT_IMAGE_VIEW_TYPES.TXT,
] as const;

/** All image groups requested by PDPs, including the separate label gallery. */
export const PDP_IMAGE_VIEW_TYPES = [
    PRODUCT_IMAGE_VIEW_TYPES.SFS,
    PRODUCT_IMAGE_VIEW_TYPES.SFA,
    PRODUCT_IMAGE_VIEW_TYPES.SN,
    PRODUCT_IMAGE_VIEW_TYPES.LAB,
    PRODUCT_IMAGE_VIEW_TYPES.TXT,
] as const;

export function toImgTypes(viewTypes: readonly string[]): string {
    return [...new Set(viewTypes)].join(',');
}

export const PDP_IMG_TYPES = toImgTypes(PDP_IMAGE_VIEW_TYPES);
export const PRODUCT_CARD_IMG_TYPES = PRODUCT_IMAGE_VIEW_TYPES.SN;
